<template>
  <div class="info-base">
    <div class="text">
      <p>国家级工美大师、非遗传承人</p>
      <p>等大量专家教授和顶尖行业大师</p>
      <p>与您共同开拓</p>
      <div class="desc">
        平台内聚合了清华美院及其他专业学院师资资源、中国工艺美术大师及省级大师、国家级及省级非遗传承人等大量专家教授和顶尖行业大师；以研究型教育、普通高等教育、职业技术教育、继续教育不同层次和不同类别的课程为依托，致力做全国最大的传统工艺一站式教育平台，为我国工艺美术教育事业以及工艺美术产业的发展贡献力量。
      </div>
    </div>
    <div class="entry">
      <div class="content">
        <div class="box">
          <h4>国家工艺美术大师</h4>
          <p>师资</p>
          <div class="btn" @click="handleClickToDetail">进入</div>
        </div>
        <div class="line"></div>
        <div class="box">
          <h4>非遗传承人</h4>
          <p>师资</p>
          <div class="btn" @click="handleClickToDetail">进入</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBase",
  data() {
    return {};
  },
  methods: {
    handleClickToDetail() {
      this.$router.push({
        path: "/InfoBaseDetail",
      });
    },
  },
};
</script>

<style lang="scss">
.info-base {
  border-top: 1px solid #f2f2f2;
  display: flex;
  padding-top: 60px;
  height: 667px;
  .text {
    width: 45.3vw;
    min-width: 580px;
    padding: 6.8vw 2vw 0 8vw;
    p {
      margin: 0;
      font-size: 26px;
      color: #2d3f51;
    }
    .desc {
      margin-top: 20px;
      border-top: 2px solid #2d3f51;
      padding-top: 54px;
      line-height: 42px;
      font-size: 17px;
      color: #7f7f7f;
    }
  }
  .entry {
    width: 54.7vw;
    min-width: 700px;
    height: 606px;
    background: url("../../assets/img/info-bg.png") no-repeat;
    background-size: cover;
    .content {
      margin: 256px 0 0 180px;
      // width: 602px;
      width: 31.35vw;
      height: 146px;
      display: flex;
      justify-content: space-between;
      .line {
        width: 1px;
        // height: 146px;
        background-color: rgba(255, 255, 255, 0.66);
      }
      .box {
        padding-top: 6px;
        text-align: center;
        h4 {
          line-height: 20px;
          font-size: 20px;
          color: #fff;
          margin-bottom: 25px;
        }
        p {
          line-height: 15px;
          font-size: 15px;
          color: #fff;
          margin-bottom: 33px;
        }
        .btn {
          margin: 0 auto;
          width: 127px;
          height: 39px;
          line-height: 39px;
          border: 1px solid #fff;
          color: #fff;
          font-size: 15px;
          letter-spacing: 10px;
          user-select: none;
          transition: 0.5s;
          cursor: pointer;
          &:hover {
            background-color: #333;
            border: 1px solid #333;
          }
        }
      }
    }
  }
}
</style>
